// extracted by mini-css-extract-plugin
export default {"title":"Instructions_title__RyT9y","description":"Instructions_description__ml5JP"};